<script>
    import { mapGetters } from "vuex";
    import LiteCompareTable from "./LiteCompareTable";
    import LiteCompareHeader from "./LiteCompareHeader";
    import LiteCompareMobile from "./LiteCompareMobile";

    export default {
        name: "LiteCompare",
        components: { LiteCompareMobile, LiteCompareHeader, LiteCompareTable },
        props: {
            specifications: {
                type: Array,
                required: true,
            },
            productsIds: {
                type: Array,
                required: true,
            },
            imagesList: Object,
            headerTopMargin: Number,
            headerStartPosition: {
                type: Object,
                default: () => ({
                    mobile: 100,
                    desktop: 500,
                }),
            },
            showColorsList: {
                type: Boolean,
                default: true,
            },
            colorsListSize: {
                type: String,
                default: "sm",
            },
            showStopDivider: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                productsList: [],
            };
        },
        computed: {
            ...mapGetters("Root", ["productsInCartIds"]),
        },
        mounted() {
            this.$store.productsApi
                .getProductsListById({
                    listIds: this.productsIds,
                    filterAvailable: false,
                })
                .then(({ items }) => {
                    const sortedProducts = [];
                    this.productsIds.forEach((id) => {
                        items.forEach((product) => {
                            if (id === product.id) {
                                sortedProducts.push(product);
                            }
                        });
                    });

                    this.productsList = sortedProducts;
                });
        },
    };
</script>

<template>
    <div class="lite-compare">
        <lite-compare-header
            :products="productsList"
            :images-list="imagesList"
            :top-margin="headerTopMargin"
            :start-position="headerStartPosition.desktop"
        ></lite-compare-header>

        <div class="lite-compare__table">
            <lite-compare-table
                :specifications="specifications"
                :products="productsList"
                :in-cart-list="productsInCartIds"
                :images-list="imagesList"
                :show-colors-list="showColorsList"
                :colors-list-size="colorsListSize"
            ></lite-compare-table>
        </div>

        <div class="lite-compare__mobile">
            <lite-compare-mobile
                :specifications="specifications"
                :products="productsList"
                :in-cart-list="productsInCartIds"
                :images-list="imagesList"
                :show-colors-list="showColorsList"
                :colors-list-size="colorsListSize"
                :top-margin="headerTopMargin"
                :start-position="headerStartPosition.mobile"
            ></lite-compare-mobile>
        </div>

        <div v-if="showStopDivider" class="js-stop-scroll-comparison"></div>
    </div>
</template>

<style lang="scss">
    .lite-compare__table {
        display: none;
        @include bp($bp-desktop-sm) {
            display: block;
        }
    }

    .lite-compare__mobile {
        @include bp($bp-desktop-sm) {
            display: none;
        }
    }
</style>
